var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.91659 5.41748L2.24992 0.66748C1.91659 0.334147 1.41659 0.334147 1.08325 0.66748C0.749919 1.00081 0.749919 1.50081 1.08325 1.83415L5.16659 5.91748L1.08325 10.0008C0.916585 10.1675 0.833252 10.3341 0.833252 10.5841C0.833252 11.0841 1.16659 11.4175 1.66659 11.4175C1.91659 11.4175 2.08325 11.3341 2.24992 11.1675L6.99992 6.41748C7.24992 6.25081 7.24992 5.75081 6.91659 5.41748Z",
    fill: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.368252c88e4b1b6e44a552109300776e.svg";
export { ForwardRef as ReactComponent };